<template>
  <v-tabs v-model="tab">
    <v-tab
      class="font-weight-medium text-subtitle-2 text-sm-subtitle-1"
      :to="{ path: `/class/mark/${classData.id}` }"
    >
      Bảng điểm
    </v-tab>
    <v-tab
      v-if="finalCourseMark"
      class="font-weight-medium text-subtitle-2 text-sm-subtitle-1"
      :to="{ path: `/class/${classData.id}/mark-sheets` }"
    >
      Phiếu điểm
    </v-tab>
    <v-tab
      v-if="finalCourseMark"
      class="font-weight-medium text-subtitle-2 text-sm-subtitle-1"
      :to="{ path: `/class/${classData.id}/retest-mark-sheet` }"
    >
      Phiếu điểm thi lại
    </v-tab>
  </v-tabs>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('classDetail', ['classData', 'finalCourseMark'])
  }
}
</script>

<style scoped></style>
